import $ from "jquery";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";

import SummaryItem from "components/SummaryItem";
import Logo from "components/Logo";
import ThemeButton from "./../components/ThemeButton";

import "css/SummaryPage.css";
import { deleteProduct, changeProductQuantity } from "actions";
import Cart from "components/Cart";

class SummaryPage extends Component {
    quantityChange(index, event) {
        let value = event.target.value;

        if (value < 1) return;

        this.props.changeProductQuantity(index, value);
    }

    deleteProduct(index) {
        this.props.deleteProduct(index);
    }

    finish() {
        // if there's no item, don't do anything.
        if (this.props.ProductList.length === 0) return;

        // Save raw quote data to sessionStorage
        sessionStorage.setItem(
            "quoteData",
            JSON.stringify({
                ProductList: this.props.ProductList,
                Customer: this.props.Customer,
            }),
        );

        // redirect depending on customer type
        if (this.props.Customer.Type === "Other") {
            this.props.history.push("/GetQuote/ContactDetails");
        } else {
            this.props.history.push("/GetQuote/WantPrice");
        }
    }

    render() {
        return (
            <div className="SummaryPage">
                <Logo topLeft={true} />
                <Cart />
                <h1>Summary</h1>
                <p className="UserPrompt">Almost there, just give the details a quick check.</p>
                <Column>
                    <div className="SummaryItemList">
                        {$.map(this.props.ProductList, (value, index) => {
                            return (
                                <Row isColumn key={value.Name}>
                                    <SummaryItem
                                        Product={value}
                                        onDelete={this.deleteProduct.bind(this, index)}
                                        onChange={this.quantityChange.bind(this, index)}
                                        openOnLoad={index === 0}
                                    />
                                </Row>
                            );
                        })}
                    </div>

                    <div className="button-panel">
                        <Row>
                            <Column centerOnSmall centerOnMedium centerOnLarge>
                                <Link className="button hollow grey" to="/Item/Selector">
                                    Add another Product
                                </Link>
                                <ThemeButton onClick={this.finish.bind(this)}>Finish!</ThemeButton>
                            </Column>
                        </Row>
                        <ThemeButton className="next">Next</ThemeButton>
                    </div>
                </Column>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ProductList: state.ProductList,
        Customer: state.TradeCustomer,
    };
};

export default withRouter(
    connect(mapStateToProps, { deleteProduct, changeProductQuantity })(SummaryPage),
);



// WEBPACK FOOTER //
// ./src/containers/SummaryPage.js